export default "__VITE_ASSET__DplgUDiZ__"